import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService, AmdocsTimeService } from 'amdocs-auth-package';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(
    private appSyncClient: AmdocsAppsyncClientService,
    private timeService: AmdocsTimeService
  ) {
  }

  public getNotifications(): Observable<INotificationItem[]> {
    const query = `
query GetNotifications {
  getNotifications {
    body {
      subject
      text
      language
    },
    resource {
      link
      type
      inTab
    },
    categoryCode
    sentTimestamp
  },
  getLastQueryTimestamp {
    timestamp
  }
}
`;
    return this.appSyncClient.callCNS(query, 'GetNotifications').pipe(
      mergeMap((response: any): Observable<INotificationItem[]> => {
        const lastTs = response.getLastQueryTimestamp?.timestamp || 0;
        response.getNotifications = response.getNotifications.sort((a, b) => {
          return a.sentTimestamp < b.sentTimestamp ? 1 : -1;
        });
        const ret: INotificationItem[] = response.getNotifications.map((item): INotificationItem => {
          return {
            categoryCode: item.categoryCode,
            language: item.body.direction ? item.body.direction : item.body.language,
            description: item.body.text,
            displayDate: this.timeService.moment(parseInt(item.sentTimestamp, 10)).format('YYYY-MM-DD HH:mm:ss'),
            linkToArticle: (item.resource?.link)?item.resource.link:null, // 'https://misnp.amdocs.com/sas/assets/goodies/ISR/f4e511a7-17fd-4f6d-8bfc-8d1549d832c5.png',
            inTab: item.resource?.inTab,
            internal: item.resource?.type === 'internal',
            isNew: item.sentTimestamp > lastTs
          };

        });
        return of(ret);
      })
    );
  }

  public addLastQueryTimestamp(): Observable<boolean> {
    const query = `
      mutation AddLastQueryTimestamp {
        addLastQueryTimestamp {
          timestamp
        }
      }`;
    return this.appSyncClient.call(query, 'AddLastQueryTimestamp', null, false, true).pipe(mergeMap((response: any) => {
      return of(!!response.addLastQueryTimestamp.timestamp);
    }));
  }
}

export interface INotificationItem {
  description: string;
  displayDate: string;
  linkToArticle?: string;
  isNew?: boolean;
  language?: string;
  categoryCode?: string;
  inTab?: boolean;
  internal?: boolean;
}

